export default __webpack_public_path__ + "static/broderie8.mobile.inspirations-e5a5e40fa8f19432b34b4709ed50efd0.jpg";